/**
 * Match Detail Component
 * Shows detailed match view with live stream and score card
 * Desktop: Uses CricketBetUi layout
 * Mobile: Uses MobileCricketUi layout
 */

import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useScreenSize } from '@/hooks/useScreenSize';
import MatchDetailDesktop from './MatchDetailDesktop';
import MatchDetailMobile from './MatchDetailMobile';
import styles from './MatchDetail.module.css';

const MatchDetail = () => {
  const { matchId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { isMobile } = useScreenSize();
  const [matchData, setMatchData] = useState(location.state?.matchData || null);
  const [isLoading, setIsLoading] = useState(!matchData);

  // If no match data in state, try to fetch it
  useEffect(() => {
    if (!matchData && matchId) {
      // You can add a fetch here if needed
      // For now, we'll use the data from navigation state
      setIsLoading(false);
    }
  }, [matchData, matchId]);

  // If no match data, redirect back
  useEffect(() => {
    if (!isLoading && !matchData) {
      navigate('/sports/popular', { replace: true });
    }
  }, [isLoading, matchData, navigate]);

  if (isLoading) {
    return (
      <div className={styles.matchDetail}>
        <div className={styles.loadingContainer}>
          <div className={styles.loader}>
            <span className={styles.loaderText}>loading</span>
            <span className={styles.load}></span>
          </div>
        </div>
      </div>
    );
  }

  if (!matchData) {
    return null;
  }

  // Render desktop or mobile view
  return isMobile ? (
    <MatchDetailMobile matchData={matchData} />
  ) : (
    <MatchDetailDesktop matchData={matchData} />
  );
};

export default MatchDetail;
